import React, { useCallback } from 'react';
import sanitizeHtml from 'sanitize-html';
import { Search } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getSearchResultLinkParams, highlightText } from './helpers';
import { LinkWrapperStyled, SearchItemStyled } from './styled';
export function SearchSuggestionItem({ suggestion: { displayText, query }, textToHighlight, searchResultsPageUrl, isActive, handleClickLink, }) {
    const text = highlightText(displayText, textToHighlight);
    const onClickLink = useCallback(() => {
        handleClickLink(query);
    }, [handleClickLink, query]);
    return (React.createElement(SearchItemStyled, { isActive: isActive },
        React.createElement(LinkWrapperStyled, { to: {
                pathname: searchResultsPageUrl,
                search: getSearchResultLinkParams(query),
            }, onClick: onClickLink },
            React.createElement(SVGIcon, { size: ICON_SIZE.xs, type: Search }),
            React.createElement(RegularTextLevel4, { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(text),
                } }))));
}
